export class ApiEndpoints {
  public static translations = {
    allLocales: '/form/data-set-provider/v3/73/LocalesTree/data/list',
    translationBase: '/mbe/api/v2/translations',
  }
}
